let modalDepth = 0;
let lockedScrollY = 0;

function applyScrollLock() {
  lockedScrollY = window.scrollY || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${lockedScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function releaseScrollLock() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, lockedScrollY);
}

export function modalOpen() {
  modalDepth += 1;
  if (modalDepth === 1) {
    applyScrollLock();
    document.body.classList.add('modal-blur');
  }
  if (modalDepth === 2) {
    document.body.classList.add('modal-blur-deep');
  }
}

export function modalClose() {
  modalDepth = Math.max(0, modalDepth - 1);
  if (modalDepth < 2) {
    document.body.classList.remove('modal-blur-deep');
  }
  if (modalDepth === 0) {
    document.body.classList.remove('modal-blur');
    releaseScrollLock();
  }
}

